import {observer} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import ReactPaginate from 'react-paginate'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {withRouter} from 'react-router-dom'
import PageSubHeader from '../../components/common/page_sub_header'
import TableCell from '../../components/control/table/table_cell'
import TableHeader from '../../components/control/table/table_header'
import {tbAnalystEditHeaders} from '../../config/constTable'
import {Page_settings} from '../../config/page_settings'
import {
  customDateFormat,
  drawTableBJPointCell,
  drawTableTitleCell,
  formatNumber,
  string,
  fphoto
} from '../../helper/common'
import strings from '../../lang/strings'
import {MaleUrl, PAGECOUNT} from '../../config/const'
import {rootStore} from '../../mobx/store'
import TableHeaderBetting from '../../components/control/table/table_header_betting'
import TableCellBettingResult from '../../components/control/table/table_cell_betting_result'
import ConfirmButton from '../../components/control/button/confirm_button'

const AnalystBettingDetail = observer((props) => {
  const result = props.location.state.result
  const context = useContext(Page_settings)
  let [dataList, setDataList] = useState([])
  let [pageCount, setPageCount] = useState(0)
  let [bettingDataList, setBettingDataList] = useState([])
  let [bettingDataList2, setBettingDataList2] = useState([])

  let [expectRate, setExpectRate] = useState(0)
  let [expectAmount, setExpectAmount] = useState(0)
  let [expectCoin, setExpectCoin] = useState(0)
  let [expectGainRate, setExpectGainRate] = useState(0)

  let [expectRate2, setExpectRate2] = useState(0)
  let [expectAmount2, setExpectAmount2] = useState(0)
  let [expectCoin2, setExpectCoin2] = useState(0)
  let [expectGainRate2, setExpectGainRate2] = useState(0)

  const tbHeaders = [
    {
      name: strings.number,
      class: 'td-pro-betting-num',
    },
    {
      name: strings.game_date,
      class: 'td-pro-betting-game-date',
    },
    {
      name: strings.league,
      class: 'td-pro-betting-league',
    },
    {
      name: strings.betting_line,
      class: 'td-pro-betting-line',
      is_result: true
    },
    {
      name: strings.remark,
      class: 'td-pro-betting-remark',
    }
  ]

  useEffect(() => {
    if (result == null) {
      props.history.back()
    }
    getTable()
    getData(1)
  }, [result])

  const getTable = () => {
    context.post('data/game_list', {uid: result.dat_id, type : 1},
      response => {
        let list = response.game_list
        let betting = parseFloat(result.dat_bae)
        for (let i = 0; i < list.length; i++) {
          if (list[i].dg_i_win == 1) {
            list[i].sel = 0
          } else if (list[i].dg_i_tie == 1) {
            list[i].sel = 1
          } else if (list[i].dg_i_loss == 1) {
            list[i].sel = 2
          } else {
            list[i].sel = -1
          }
          list[i].ans = list[i].hit_type ?? -1
        }
        let bae = betting
        if (result.dat_status > 1) {
          betting = parseFloat(result.dat_gain)
        }

        setBettingDataList(list)

        let bettingAmount = parseInt(result.dat_price)
        let hit_val = parseInt(betting * bettingAmount)

        setExpectAmount(bettingAmount)
        setExpectRate(bae)
        setExpectCoin(hit_val)
        setExpectGainRate(parseInt(betting * 100))
      }
    )
    if (result.dat_note2 || true) {
      context.post('data/game_list', {uid: result.dat_id, type: 0},
        response => {
          let list = response.game_list
          let betting2 = parseFloat(result.dat_bae2)
          for (let i = 0; i < list.length; i++) {
            if (list[i].dg_i_win == 1) {
              list[i].sel = 0
            } else if (list[i].dg_i_tie == 1) {
              list[i].sel = 1
            } else if (list[i].dg_i_loss == 1) {
              list[i].sel = 2
            } else {
              list[i].sel = -1
            }
            list[i].ans = list[i].hit_type ?? -1
          }
          let bae2 = betting2
          if (result.dat_status > 1) {
            betting2 = parseFloat(result.dat_gain2)
          }

          setBettingDataList2(list)

          let bettingAmount2 = parseInt(result.dat_price2)
          let hit_val2 = parseInt(betting2 * bettingAmount2)

          setExpectAmount2(bettingAmount2)
          setExpectRate2(bae2)
          setExpectCoin2(hit_val2)
          setExpectGainRate2(parseInt(betting2 * 100))
        }
      )
    }
  }

  const getData = (page) => {
    context.post('data/data_list', {mb_id: result.mb_id, cate: result.dat_cate, page: page, count: PAGECOUNT},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setDataList(response.list)
        setPageCount(response.page_count)
      }
    )
  }

  const goResult = (result) => {
    props.history.replace('/analyst/betting_detail', {result: result})
  }

  const onRegister = (data) => {
    props.history.push('/my_data/analyst_new_betting', {data: data})
  }

  const onDetail = (result) => {
    if (result.is_readable == 0) {
      context.showAlert(strings.data_disabled)
      return
    }

    if (result.is_purchased == 0) {
      context.showPointUse(result.mb_nick, result.dat_po, () => {
        const mb_point = rootStore.getMe.mb_point
        if (Number(mb_point) < Number(result.dat_po)) {
          context.showPointLack(1, result.dat_po, () => {
            context.showPointPay()
          })
          return
        }
        context.post('pay/andata_buy', {dat_id: result.dat_id},
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => {context.showAlert(err.msg)}, 500)
          }
        )
      })
      return
    }
    goResult(result)
  }

  const onDelete = (info) => {
    if (info.other_purchased == 1) {
      return
    }
    context.showConfirm(strings.ask_delete, (val) => {
      if (!val) return
      context.post('data/data_delete', {dat_id: info.dat_id},
        () => {
          if (info.dat_id == result.dat_id) {
            props.history.goBack()
          }

          getTable()
          getData(1)
        },
        true,
        err => {
          setTimeout(() => {context.showAlert(err.msg)}, 500)
        }
      )
    })
  }

  const handlePageClick = (component) => {
    const nextPage = component.selected + 1
    getData(nextPage)
  }

  return (
    <React.Fragment>
      <div className='im-container im-container-no-sidebar sm-ph-15'>
        <PageSubHeader pageName={''} pageMenu1={strings.main} pageMenu2={strings.analyst_member} pageMenu={strings.betting_box}/>
        <div className='bj-result-area mt-30 sm-mt-0 sm-pb-32'>
          <div className={'w-100 text-right-center'}>
          {(result.mb_id == rootStore.getMe.mb_id && result.other_purchased == 0) &&
             <ConfirmButton enabled={true} className={'btn-modify fs-14 f-sb mb-20'} onClick={() => {onDelete(result)}} text={strings.delete}/>}
          </div>
          <div className='fs-28 sm-fs-18 f-b justify-content-center text-center word-keep ph-20 sm-ph-40'>{result.dat_title}</div>
          <div className='d-flex bj-result-profile mt-40 bd-0'>
            <div className='d-flex align-items-center flex-full'>
              <img className='bj-profile' src={fphoto(result.mb_photo, 'member', MaleUrl)} alt={''} />
              <div className='fs-18 sm-fs-16 f-sb ml-14 sm-ml-6 color-3a3335'>{strings.member + ' ' + result.mb_nick}{result.mb_new == 1 && <img className='icon_new' src='/assets/image/new.png' alt=''/>}</div>
            </div>
            <div className={'d-flex'}>
              <div className='fs-14 sm-fs-12 f-m color-9e9e9e'>{result.dat_s_year + strings.year + ' ' + result.dat_s_round + strings.times}</div>
              <div className='fs-14 sm-fs-12 color-d9d9d9 ph-20 sm-ph-10'>{'|'}</div>
              <div className='fs-14 sm-fs-12 f-m color-9e9e9e'>등록일시 : {customDateFormat(result.dat_createdat)}</div>
            </div>
          </div>
        </div>
        <div className='bj-result-area sm-ph-0 mt-12'>
          <div className='fs-20 sm-fs-16 f-b color-3a3335 sm-ml-15'>{strings.main_power}</div>
          <div className='shadow-div position-relative'>
            <PerfectScrollbar className='div_sale mt-20 div_game'>
              <TableHeaderBetting className={''} headers={tbHeaders}/>
              {
                bettingDataList.map((info, index) => {
                  return (
                    <div key={index} className='tb-row-betting tb-row-betting1'>
                      <TableCell
                        value={info.btm_match_seq}
                        className={tbHeaders[0].class + ' td-cell-primary'}
                        center={tbHeaders[0].center}
                        child={null}
                      />
                      <TableCell
                        value={customDateFormat(info.round_start)}
                        className={tbHeaders[1].class + ' td-cell-primary'}
                        center={tbHeaders[1].center}
                        child={null}
                      />
                      <TableCell
                        value={info.league_name}
                        className={tbHeaders[2].class + ' td-cell-primary'}
                        center={tbHeaders[2].center}
                        child={null}
                      />
                      <TableCellBettingResult
                        betting_type={info.betting_type}
                        home={info.home_name}
                        away={info.away_name}
                        winScore={info.home_dividend_rate}
                        winUp={ info.prev_home_dividend_rate }
                        loseScore={info.away_dividend_rate}
                        loseUp={ info.prev_away_dividend_rate }
                        drawScore={info.no_odds}
                        drawUp={info.prev_no_odds}
                        handi={info.handicap_standard}
                        uo={info.uo_standard}
                        selected={info.sel}
                        ans={info.ans}
                        className={tbHeaders[3].class + ' td-cell-primary'}
                        center={tbHeaders[3].center}
                        child={null}
                        onSelectChange={() => {}}
                      />
                      <TableCell
                        value={''}
                        className={tbHeaders[4].class + ' td-cell-primary'}
                        center={tbHeaders[4].center}
                        child={null}
                      />
                    </div>
                  )
                })
              }
            </PerfectScrollbar>
          </div>
          <div className='expect-betting-result fs-18 f-b color-3a6d99 border-top-0'>{result.dat_status > 1 ? strings.result_betting_result : strings.expectant_betting_result}</div>
          <div className={'detail-result-info border-top-0 d-flex d-flex fs-18 sm-fs-14 f-b'}>
            <div className='d-center flex-full'>
              <div className='d-block'>
                <div className='d-flex'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{strings.betting_amount}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectAmount))}</div>
                </div>
                <div className='d-flex mt-10'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_amount : strings.expectant_amount}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectCoin))}</div>
                </div>
              </div>
            </div>
            <div className='d-center flex-full'>
              <div className='d-block'>
                <div className='d-flex'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_rate : strings.expectant_rate}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_rate, expectRate)}</div>
                </div>
                <div className='d-flex mt-10'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_gain_rate : strings.expectant_gain_rate}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_pro, formatNumber(expectGainRate))}</div>
                </div>
              </div>
            </div>
          </div>
          <div className='fs-20 sm-fs-16 f-b color-3a3335 mb-20 sm-mb-14 pt-40 sm-pt-30 pb-16 sm-pb-8 sm-mh-15 detail-comment-label'>{strings.comment}</div>
          <div className='bj-note mt-20 fs-16 sm-fs-14 sm-ph-15' dangerouslySetInnerHTML={{ __html: result.dat_note }} />
        </div>
        {bettingDataList2.length > 0 &&
        <div className='bj-result-area sm-ph-0 mt-12'>
          <div className='fs-20 sm-fs-16 f-b color-3a3335 sm-ml-15'>{strings.sub_power}</div>
          <div className='shadow-div position-relative'>
            <PerfectScrollbar className='div_sale mt-20 div_game'>
              <TableHeaderBetting className={''} headers={tbHeaders}/>
              {
                bettingDataList2.map((info, index) => {
                  return (
                    <div key={index} className='tb-row-betting tb-row-betting1'>
                      <TableCell
                        value={info.btm_match_seq}
                        className={tbHeaders[0].class + ' td-cell-primary'}
                        center={tbHeaders[0].center}
                        child={null}
                      />
                      <TableCell
                        value={customDateFormat(info.round_start)}
                        className={tbHeaders[1].class + ' td-cell-primary'}
                        center={tbHeaders[1].center}
                        child={null}
                      />
                      <TableCell
                        value={info.league_name}
                        className={tbHeaders[2].class + ' td-cell-primary'}
                        center={tbHeaders[2].center}
                        child={null}
                      />
                      <TableCellBettingResult
                        betting_type={info.betting_type}
                        home={info.home_name}
                        away={info.away_name}
                        winScore={info.home_dividend_rate}
                        winUp={ info.prev_home_dividend_rate }
                        loseScore={info.away_dividend_rate}
                        loseUp={ info.prev_away_dividend_rate }
                        drawScore={info.no_odds}
                        handi={info.handicap_standard}
                        uo={info.uo_standard}
                        selected={info.sel}
                        ans={info.ans}
                        className={tbHeaders[3].class + ' td-cell-primary'}
                        center={tbHeaders[3].center}
                        child={null}
                        onSelectChange={() => {}}
                      />
                      <TableCell
                        value={''}
                        className={tbHeaders[4].class + ' td-cell-primary'}
                        center={tbHeaders[4].center}
                        child={null}
                      />
                    </div>
                  )
                })
              }
            </PerfectScrollbar>
          </div>
          <div className='expect-betting-result fs-18 f-b color-3a6d99 border-top-0'>{result.dat_status > 1 ? strings.result_betting_result : strings.expectant_betting_result}</div>
          <div className={'detail-result-info border-top-0 d-flex d-flex fs-18 sm-fs-14 f-b'}>
            <div className='d-center flex-full'>
              <div className='d-block'>
                <div className='d-flex'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{strings.betting_amount}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectAmount2))}</div>
                </div>
                <div className='d-flex mt-10'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_amount : strings.expectant_amount}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectCoin2))}</div>
                </div>
              </div>
            </div>
            <div className='d-center flex-full'>
              <div className='d-block'>
                <div className='d-flex'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_rate : strings.expectant_rate}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_rate, expectRate2)}</div>
                </div>
                <div className='d-flex mt-10'>
                  <div className='wx-120 sm-wx-74 color-3a3335'>{result.dat_status > 1 ? strings.result_gain_rate : strings.expectant_gain_rate}</div>
                  <div className='color-e45a5a'>{string.Format(strings.format_pro, formatNumber(expectGainRate2))}</div>
                </div>
              </div>
            </div>
          </div>
          <div className='fs-20 sm-fs-16 f-b color-3a3335 mb-20 sm-mb-14 pt-40 sm-pt-30 pb-16 sm-pb-8 sm-mh-15 detail-comment-label'>{strings.sub_power_analyst}</div>
          <div className='bj-note mt-20 fs-16 sm-fs-14 sm-ph-15' dangerouslySetInnerHTML={{ __html: result.dat_note2 }} />
        </div>
        }
        <div className='fs-20 sm-fs-16 f-b mt-60 sm-mt-35 color-3a3335'>{strings.analyst_data}</div>
        <div className='shadow-div position-relative'>
          <PerfectScrollbar className='div_sale mt-20 sm-mt-14 mb-40'>
            <TableHeader className={'bg-white'} headers={tbAnalystEditHeaders}/>
            {
              dataList.map((info, index) => {
                return (
                  <div key={index} className='tb-row cursor-point'>
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                      className={tbAnalystEditHeaders[0].class}
                      center={tbAnalystEditHeaders[0].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={info.sk_name ?? '-'}
                      className={tbAnalystEditHeaders[1].class}
                      center={tbAnalystEditHeaders[1].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={customDateFormat(info.dat_start)}
                      className={tbAnalystEditHeaders[2].class}
                      center={tbAnalystEditHeaders[2].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={info.dat_title}
                      className={tbAnalystEditHeaders[3].class}
                      center={tbAnalystEditHeaders[3].center}
                      child={drawTableTitleCell(info.dat_title, info.data_new)}
                    />
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={info.mb_nick}
                      className={tbAnalystEditHeaders[4].class}
                      center={tbAnalystEditHeaders[4].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => {onDetail(info)}}
                      value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                      color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color: strings.no_buy_color)}
                      className={tbAnalystEditHeaders[5].class}
                      center={tbAnalystEditHeaders[5].center}
                      child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                    />
                    <TableCell
                      value={''}
                      className={tbAnalystEditHeaders[6].class}
                      center={tbAnalystEditHeaders[6].center}
                      child={
                        <div className={'d-center w-100 h-100'}>
                            {info.mb_id == rootStore.getMe.mb_id && 
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m' }
                                    onClick={() => { onDelete(info); }}
                                    text={strings.delete}
                                  />}
                          </div>
                      }
                    />
                  </div>
                )
              })
            }
          </PerfectScrollbar>
        </div>
        {pageCount > 1 &&
        <ReactPaginate
          previousLabel={''}
          nextLabel={''}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
        }
      </div>
    </React.Fragment>
  )
})

export default withRouter(AnalystBettingDetail)
